const getIconColor = (type, v) => {

      // const  color_code = type == 'date' ? v !=null?"#8fbc8f": "#696969" : v ?  "#8fbc8f": "#696969"
      const  color_code = type == 'date' ? v !=null?"#8fbc8f": "rgb(199, 189, 189)" : v ?  "#8fbc8f": "#696969"
      
      // const  color_code = v !=null?"#696969": "#8fbc8f"
      return color_code

}

export default getIconColor
